import { Action, ActionDropdown } from 'components';
import type { ReactElement } from 'react';
import { useIOActions } from '../io';
import { useOnOpenSummary } from './Summary';

export function MoreActionsButton(): ReactElement {
  const onOpenSummary = useOnOpenSummary();

  const actions: (Action | '-' | ReactElement)[] = [
    ...useIOActions(),
    '-',
    {
      action: 'summary',
      button: {
        children: 'Plan summary',
        onClick: onOpenSummary,
        icon: 'list-tree',
      },
    },
  ];
  return (
    <ActionDropdown
      actions={actions}
      variant="secondary"
      icon="ellipsis-vertical"
      testId="more-actions"
      size="sm"
      title="More actions"
    />
  );
}
